var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"survey__row__container__row answer"},[_c('div',{staticClass:"survey__row__container__row__cell"},[_vm._v(_vm._s(_vm.answer))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }